import { render, staticRenderFns } from "./BCXCheckbox.vue?vue&type=template&id=7bb38ae1&scoped=true"
import script from "./BCXCheckbox.vue?vue&type=script&lang=ts&setup=true"
export * from "./BCXCheckbox.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BCXCheckbox.vue?vue&type=style&index=0&id=7bb38ae1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb38ae1",
  null
  
)

export default component.exports